"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const img_scale_vue_1 = tslib_1.__importDefault(require("./components/img-scale.vue"));
const __sfc_main = {};
__sfc_main.props = ['reason', 'advisorName', 'advisorAvatar', 'advisorTle', 'viewPerson', 'personlink', 'desc', 'descImg'];
__sfc_main.setup = (__props, __ctx) => {
    const { useLang, useBehaviour } = require('@fegobull/webapi').use;
    const { runBehaviour } = useBehaviour();
    const { langText } = useLang();
    const props = __props;
    const imgScaleRef = (0, vue_demi_1.ref)(null);
    // 图片查看器状态
    const showImageViewer = (0, vue_demi_1.ref)(false);
    // 打开图片查看器
    const openImageViewer = () => {
        showImageViewer.value = true;
        (0, vue_demi_1.nextTick)(() => {
            var _a;
            (_a = imgScaleRef.value) === null || _a === void 0 ? void 0 : _a.resetImgViewer();
        });
    };
    // 关闭图片查看器
    const closeImageViewer = () => {
        showImageViewer.value = false;
    };
    const jumpToLink = evt => {
        let url = props.personlink;
        if (!url) {
            return;
        }
        if (url.startsWith('ftnn')) {
            url = `futunn${url.slice('ftnn'.length)}`;
            location.href = url;
            return;
        }
        if (url.startsWith('ftmm')) {
            url = `futumm${url.slice('ftmm'.length)}`;
            location.href = url;
            return;
        }
        if (url.startsWith('futunn')) {
            // url = 'ftnn' + url.slice('futunn'.length);
            location.href = url;
            return;
        }
        if (url.startsWith('futumm')) {
            // url = 'ftmm' + url.slice('futumm'.length);
            location.href = url;
            return;
        }
        runBehaviour(this, {
            withQuery: true,
            type: 'link',
            value: props.personlink
        }, evt, null);
    };
    return {
        langText,
        imgScaleRef,
        showImageViewer,
        openImageViewer,
        closeImageViewer,
        jumpToLink
    };
};
__sfc_main.components = Object.assign({
    ImgScale: img_scale_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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